import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import * as ThemeActions from './theme.actions';

@Injectable()
export class ThemeEffects {
  // Save theme to localStorage whenever it changes
  saveTheme$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ThemeActions.setTheme, ThemeActions.toggleTheme),
        tap((action) => {
          const theme = action.type === ThemeActions.setTheme.type ? action['theme'] : undefined;

          // If setTheme, save directly, otherwise get current theme from DOM
          if (theme) {
            localStorage.setItem('theme', theme);
            this.applyTheme(theme);
          } else {
            // Toggle case - check current and switch
            const currentTheme = localStorage.getItem('theme') || 'light';
            const newTheme = currentTheme === 'light' ? 'dark' : 'light';
            localStorage.setItem('theme', newTheme);
            this.applyTheme(newTheme);
          }
        })
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}

  private applyTheme(theme: 'light' | 'dark'): void {
    if (theme === 'dark') {
      document.body.classList.add('dark-theme');
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
      document.body.classList.remove('dark-theme');
    }
  }
}
